/**
 * Self-funding sequence, step 4: the coverage projection, counting every recorded policy. Two choices:
 * finish with self-funding ("Back to your plan" once the plan is finished), or explore insurance options
 * in the consumer flow. Both stay disabled until the figures are ready; nothing missing is ever shown
 * as $0. Chosen from the options' self-fund link it offers something else; see `useProjectionChoices`.
 */
import { FundingAssessmentProjection } from '@/features/funding-sources';
import { FundingScreenFrame } from '../components/funding-screen-frame';
import { useProjectionChoices } from '../hooks/use-projection-choices';
import { useSelfFundingSequence } from '../hooks/use-self-funding-sequence';
import type { ConsumerStepProps } from './step-props';

export function AssessmentProjectionStep({ clientId }: ConsumerStepProps) {
  const { assessment } = useSelfFundingSequence(clientId);
  const { continueActions, isSelfFundChoice, back } = useProjectionChoices(clientId);

  return (
    <FundingAssessmentProjection
      assessment={assessment}
      continueActions={continueActions}
      showInsurancePrompt={!isSelfFundChoice}
      showWellPositioned={!isSelfFundChoice}
      fullWidth
      onBack={back}
      frame={parts => (
        <FundingScreenFrame
          step="assessment-projection"
          parts={parts}
        />
      )}
    />
  );
}
